(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-seo-description"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var TYPE = 'collection-seo-description';

  function initRoot(root) {
    if (!root || root.dataset.cseoReady === '1') return;

    var wrap = root.querySelector('[data-cseo-wrap]');
    var content = root.querySelector('[data-cseo-content]');
    var toggle = root.querySelector('[data-cseo-toggle]');
    if (!wrap || !content || !toggle) return;

    root.dataset.cseoReady = '1';

    var labelMore = toggle.getAttribute('data-label-more') || 'Cargar más';
    var labelLess = toggle.getAttribute('data-label-less') || 'Cargar menos';
    var expanded = false;

    function collapsedMax() {
      var styles = window.getComputedStyle(content);
      var lineHeight = parseFloat(styles.lineHeight);
      if (!lineHeight || isNaN(lineHeight)) {
        var fontSize = parseFloat(styles.fontSize) || 16;
        lineHeight = fontSize * 1.5;
      }
      var lines = parseFloat(getComputedStyle(root).getPropertyValue('--cseo-lines')) || 5;
      return lineHeight * lines;
    }

    function updateToggleVisibility() {
      if (expanded) return;
      var needsToggle = content.scrollHeight > collapsedMax() + 2;
      toggle.hidden = !needsToggle;
      if (!needsToggle) {
        wrap.classList.add('is-expanded');
        wrap.style.maxHeight = '';
      } else {
        wrap.classList.remove('is-expanded');
        wrap.style.maxHeight = collapsedMax() + 'px';
      }
    }

    function setExpanded(next) {
      expanded = next;
      if (expanded) {
        wrap.classList.add('is-expanded');
        wrap.style.maxHeight = content.scrollHeight + 'px';
        toggle.setAttribute('aria-expanded', 'true');
        toggle.textContent = labelLess;
        requestAnimationFrame(function () {
          wrap.style.maxHeight = 'none';
        });
      } else {
        var full = content.scrollHeight;
        wrap.style.maxHeight = full + 'px';
        wrap.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = labelMore;
        requestAnimationFrame(function () {
          wrap.style.maxHeight = collapsedMax() + 'px';
        });
      }
    }

    toggle.addEventListener('click', function () {
      setExpanded(!expanded);
    });

    updateToggleVisibility();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateToggleVisibility, 150);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="' + TYPE + '"]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-section-type="' + TYPE + '"]') || event.target;
    if (root && root.getAttribute('data-section-type') === TYPE) {
      delete root.dataset.cseoReady;
      initRoot(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-subcollections"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var MQ = '(max-width: 767px)';
  var TYPE = 'collection-subcollections';

  function parseConfig(root) {
    try {
      return JSON.parse(root.getAttribute('data-scs-config') || '{}');
    } catch (e) {
      return {};
    }
  }

  function isMobile() {
    return window.matchMedia(MQ).matches;
  }

  function destroySwiperInstance(root) {
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    var swEl = document.getElementById('scs-swp-' + sectionId);
    if (swEl && swEl.swiper) {
      swEl.swiper.destroy(true, true);
    }
    root.classList.remove('scs--swiper');
  }

  function setStaticDesktop(root) {
    destroySwiperInstance(root);
    root.classList.add('scs--static');
  }

  function buildSwiper(root, cfg, attempt) {
    var sectionId = root.getAttribute('data-section-id');
    var swEl = document.getElementById('scs-swp-' + sectionId);
    if (!swEl) return;

    if (typeof Swiper === 'undefined') {
      if ((attempt || 0) < 60) {
        setTimeout(function () {
          buildSwiper(root, cfg, (attempt || 0) + 1);
        }, 50);
      }
      return;
    }

    if (swEl.swiper) {
      swEl.swiper.destroy(true, true);
    }

    var slidesMobile = cfg.slidesMobile || 2.4;
    var gapMobile = cfg.gapMobile || 12;
    var maxDesktop = cfg.maxDesktop || 7;
    var gapDesktop = cfg.gapDesktop || 16;
    var count = cfg.slideCount || 0;
    var desktopNeedsCarousel = count > maxDesktop;

    root.classList.remove('scs--static');
    root.classList.add('scs--swiper');

    var opts = {
      loop: false,
      watchOverflow: true,
      grabCursor: true,
      resistanceRatio: 0.65,
      observer: true,
      observeParents: true,
      slidesPerView: slidesMobile,
      spaceBetween: gapMobile,
      breakpoints: {
        768: {
          slidesPerView: desktopNeedsCarousel ? maxDesktop : slidesMobile,
          spaceBetween: gapDesktop
        }
      }
    };

    new Swiper(swEl, opts);
  }

  function shouldUseSwiper(cfg) {
    if (isMobile()) return true;
    var count = cfg.slideCount || 0;
    var maxDesktop = cfg.maxDesktop || 7;
    return count > maxDesktop;
  }

  function syncMode(root) {
    if (!root) return;
    var cfg = parseConfig(root);
    if (shouldUseSwiper(cfg)) {
      buildSwiper(root, cfg, 0);
    } else {
      setStaticDesktop(root);
    }
  }

  function bindMediaQuery(root) {
    if (root._scsMqBound) return;
    root._scsMqBound = true;
    var mq = window.matchMedia(MQ);
    var onChange = function () {
      syncMode(root);
    };
    root._scsMq = mq;
    root._scsOnMq = onChange;
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onChange);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onChange);
    }
  }

  function unbindMediaQuery(root) {
    if (!root || !root._scsMq || !root._scsOnMq) return;
    try {
      if (typeof root._scsMq.removeEventListener === 'function') {
        root._scsMq.removeEventListener('change', root._scsOnMq);
      } else if (typeof root._scsMq.removeListener === 'function') {
        root._scsMq.removeListener(root._scsOnMq);
      }
    } catch (e) {}
    delete root._scsMq;
    delete root._scsOnMq;
    delete root._scsMqBound;
  }

  function destroySection(root) {
    destroySwiperInstance(root);
    unbindMediaQuery(root);
  }

  function initSection(root) {
    if (!root) return;
    syncMode(root);
    bindMediaQuery(root);
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="' + TYPE + '"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.detail || !e.detail.sectionId) return;
    var sectionEl = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!sectionEl) return;
    var root = sectionEl.querySelector('[data-section-type="' + TYPE + '"]');
    if (root) initSection(root);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.detail || !e.detail.sectionId) return;
    var sectionEl = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!sectionEl) return;
    var root = sectionEl.querySelector('[data-section-type="' + TYPE + '"]');
    if (root) destroySection(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroLanding(root) {
      if (!root || !root.hasAttribute('data-hl-animate')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        root.classList.add('hl-sec--in-view');
        return;
      }
      if (!('IntersectionObserver' in window)) {
        root.classList.add('hl-sec--in-view');
        return;
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('hl-sec--in-view');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
      );
      observer.observe(root);
    }

    function boot() {
      document.querySelectorAll('[data-hl-animate]').forEach(initHeroLanding);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var el = event.target && event.target.querySelector
        ? event.target.querySelector('[data-hl-animate]')
        : null;
      if (el) initHeroLanding(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-hotspot-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ihsInit) return;
  window.__ihsInit = true;

  function canHover() {
    return window.matchMedia('(hover: hover)').matches;
  }

  function closeAllHotspots(root) {
    root.querySelectorAll('.hotspot--active').forEach(function (hotspot) {
      setHotspotOpen(hotspot, false);
    });
  }

  function prepareCardMedia(card) {
    if (window.lazySizes && window.lazySizes.loader) {
      card.querySelectorAll('.lazyload').forEach(function (el) {
        window.lazySizes.loader.unveil(el);
      });
    }
  }

  function setHotspotOpen(hotspot, open) {
    var trigger = hotspot.querySelector('.hotspot__trigger');
    var card = hotspot.querySelector('.hotspot-card');
    hotspot.classList.toggle('hotspot--active', open);
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!card) return;

    card.removeAttribute('hidden');
    card.setAttribute('aria-hidden', open ? 'false' : 'true');

    if (open) {
      prepareCardMedia(card);
      card.classList.remove('hotspot-card--open');
      card.style.transform = '';
      card.style.marginLeft = '';
      var clampCard = positionCard(hotspot, card);
      requestAnimationFrame(function () {
        card.classList.add('hotspot-card--open');
        requestAnimationFrame(function () {
          if (typeof clampCard === 'function') clampCard();
        });
      });
    } else {
      card.classList.remove('hotspot-card--open');
      card.style.transform = '';
      card.style.marginLeft = '';
    }
  }

  function positionCard(hotspot, card) {
    card.classList.remove('hotspot-card--above', 'hotspot-card--below', 'hotspot-card--left', 'hotspot-card--right');
    card.classList.add('hotspot-card--above');
    card.style.transform = '';
    card.style.marginLeft = '';

    var wrapper = hotspot.closest('.hotspot-slide__image-wrapper');
    if (!wrapper) return null;

    var wrapperRect = wrapper.getBoundingClientRect();
    var hotspotRect = hotspot.getBoundingClientRect();
    var cardRect = card.getBoundingClientRect();

    var spaceAbove = hotspotRect.top - wrapperRect.top;
    var spaceBelow = wrapperRect.bottom - hotspotRect.bottom;

    if (spaceAbove < cardRect.height + 20 && spaceBelow > spaceAbove) {
      card.classList.remove('hotspot-card--above');
      card.classList.add('hotspot-card--below');
    }

    var hotspotCenter = hotspotRect.left + hotspotRect.width / 2;
    var halfCard = cardRect.width / 2;
    if (hotspotCenter - halfCard < wrapperRect.left + 8) {
      card.classList.add('hotspot-card--left');
    } else if (hotspotCenter + halfCard > wrapperRect.right - 8) {
      card.classList.add('hotspot-card--right');
    }

    return function clampCard() {
      var isLeft = card.classList.contains('hotspot-card--left');
      var isRight = card.classList.contains('hotspot-card--right');
      var margin = 8;

      card.style.transform = '';
      var nextWrapperRect = wrapper.getBoundingClientRect();
      var nextCardRect = card.getBoundingClientRect();
      if (!nextCardRect.width || !nextCardRect.height) return;

      var viewportW = window.innerWidth || document.documentElement.clientWidth;
      var viewportH = window.innerHeight || document.documentElement.clientHeight;
      var boundLeft = Math.max(nextWrapperRect.left, 0) + margin;
      var boundRight = Math.min(nextWrapperRect.right, viewportW) - margin;
      var boundTop = Math.max(nextWrapperRect.top, 0) + margin;
      var boundBottom = Math.min(nextWrapperRect.bottom, viewportH) - margin;

      var availableH = Math.max(0, boundBottom - boundTop);
      var availableW = Math.max(0, boundRight - boundLeft);
      var scale = 1;
      if (availableH > 0 && nextCardRect.height > availableH) scale = availableH / nextCardRect.height;
      if (availableW > 0 && nextCardRect.width * scale > availableW) scale = Math.min(scale, availableW / nextCardRect.width);
      if (scale > 0.995) scale = 1;

      var xBase = isLeft || isRight ? '0px' : '-50%';
      card.style.transform = 'translate(' + xBase + ', 0px) scale(' + scale + ')';
      nextCardRect = card.getBoundingClientRect();

      var offsetX = 0;
      var offsetY = 0;
      if (nextCardRect.left < boundLeft) {
        offsetX = boundLeft - nextCardRect.left;
      } else if (nextCardRect.right > boundRight) {
        offsetX = boundRight - nextCardRect.right;
      }
      if (nextCardRect.top < boundTop) {
        offsetY = boundTop - nextCardRect.top;
      } else if (nextCardRect.bottom > boundBottom) {
        offsetY = boundBottom - nextCardRect.bottom;
      }
      if (Math.abs(offsetX) < 1) offsetX = 0;
      if (Math.abs(offsetY) < 1) offsetY = 0;
      if (!offsetX && !offsetY && scale === 1) {
        card.style.transform = '';
        return;
      }

      var xPart = isLeft || isRight ? offsetX + 'px' : 'calc(-50% + ' + offsetX + 'px)';
      card.style.transform = 'translate(' + xPart + ', ' + offsetY + 'px) scale(' + scale + ')';
    };
  }

  function initHotspots(root) {
    if (root.dataset.ihsHotspotsBound) return;
    root.dataset.ihsHotspotsBound = '1';

    var openHotspot = null;
    var leaveTimer = null;

    root.querySelectorAll('.hotspot').forEach(function (hotspot) {
      var trigger = hotspot.querySelector('.hotspot__trigger');
      if (!trigger) return;

      if (canHover()) {
        hotspot.addEventListener('mouseenter', function () {
          clearTimeout(leaveTimer);
          if (openHotspot && openHotspot !== hotspot) setHotspotOpen(openHotspot, false);
          setHotspotOpen(hotspot, true);
          openHotspot = hotspot;
        });
        hotspot.addEventListener('mouseleave', function () {
          leaveTimer = setTimeout(function () {
            setHotspotOpen(hotspot, false);
            if (openHotspot === hotspot) openHotspot = null;
          }, 220);
        });
      }

      trigger.addEventListener('click', function (e) {
        if (canHover()) return;
        e.preventDefault();
        e.stopPropagation();
        var isOpen = hotspot.classList.contains('hotspot--active');
        closeAllHotspots(root);
        if (!isOpen) {
          setHotspotOpen(hotspot, true);
          openHotspot = hotspot;
        } else {
          openHotspot = null;
        }
      });

      trigger.addEventListener('focus', function () {
        if (!canHover()) return;
        if (openHotspot && openHotspot !== hotspot) setHotspotOpen(openHotspot, false);
        setHotspotOpen(hotspot, true);
        openHotspot = hotspot;
      });
    });

    root.addEventListener('click', function (e) {
      if (e.target.closest('.hotspot__trigger')) return;
      if (!e.target.closest('.hotspot')) closeAllHotspots(root);
    });

    root._ihsResize = function () {
      root.querySelectorAll('.hotspot--active').forEach(function (h) {
        var card = h.querySelector('.hotspot-card');
        if (!card) return;
        var clampCard = positionCard(h, card);
        if (typeof clampCard === 'function') clampCard();
      });
    };
    window.addEventListener('resize', root._ihsResize);
  }

  function initSection(root, attempt) {
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;

    var swEl = document.getElementById('swp' + sectionId);
    if (!swEl) return;

    initHotspots(root);

    if (typeof Swiper === 'undefined') {
      if ((attempt || 0) < 60) {
        setTimeout(function () {
          initSection(root, (attempt || 0) + 1);
        }, 50);
      }
      return;
    }

    if (swEl.swiper) swEl.swiper.destroy(true, true);

    var autoplay = false;
    var autoplayRaw = swEl.getAttribute('data-autoplay');
    if (autoplayRaw && autoplayRaw !== 'false') {
      try {
        autoplay = JSON.parse(autoplayRaw);
      } catch (err) {
        autoplay = false;
      }
    }

    var slideCount = swEl.querySelectorAll('.swiper-slide').length;
    var loop = slideCount > 1 && swEl.getAttribute('data-loop') === 'true';

    var swiperOpts = {
      slidesPerView: 'auto',
      loop: loop,
      speed: 500,
      autoplay: autoplay,
      pagination: {
        el: '.swpg' + sectionId,
        clickable: true
      },
      navigation: {
        nextEl: '.swn' + sectionId,
        prevEl: '.swp' + sectionId
      },
      on: {
        slideChange: function () {
          closeAllHotspots(root);
        }
      }
    };

    new Swiper('#swp' + sectionId, swiperOpts);
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="image-hotspot-slider"]').forEach(initSection);
  }

  function onKeydown(e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-section-type="image-hotspot-slider"]').forEach(closeAllHotspots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('keydown', onKeydown);

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.detail || !e.detail.sectionId) return;
    var sectionEl = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!sectionEl) return;
    var root = sectionEl.querySelector('[data-section-type="image-hotspot-slider"]');
    if (root) {
      delete root.dataset.ihsHotspotsBound;
      initSection(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.detail || !e.detail.sectionId) return;
    var sectionEl = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!sectionEl) return;
    var root = sectionEl.querySelector('[data-section-type="image-hotspot-slider"]');
    if (!root) return;
    var swEl = root.querySelector('.hotspot-slider__swiper');
    if (swEl && swEl.swiper) swEl.swiper.destroy(true, true);
    if (root._ihsResize) window.removeEventListener('resize', root._ihsResize);
    delete root.dataset.ihsHotspotsBound;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-explore"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initLocalExplore(root) {
      if (!root || !root.hasAttribute('data-lex-animate')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        root.classList.add('lex-sec--in-view');
        return;
      }
      if (!('IntersectionObserver' in window)) {
        root.classList.add('lex-sec--in-view');
        return;
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('lex-sec--in-view');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
      );
      observer.observe(root);
    }

    function boot() {
      document.querySelectorAll('[data-lex-animate]').forEach(initLocalExplore);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var el =
        event.target && event.target.querySelector
          ? event.target.querySelector('[data-lex-animate]')
          : null;
      if (el) initLocalExplore(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["locations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabButtons = document.querySelectorAll('.retail-tabs-menu button');
    const tabContents = document.querySelectorAll('.retail-tab-content');

    function isMobile() {
      return window.innerWidth <= 767;
    }

    tabButtons.forEach(function (btn, idx) {
      btn.addEventListener('click', function () {
        if (isMobile()) {
          // Modo acordeón: toggle solo este
          btn.classList.toggle('active');
          if (tabContents[idx].style.display === 'flex') {
            tabContents[idx].style.display = 'none';
          } else {
            tabContents[idx].style.display = 'flex';
          }
        } else {
          // Modo desktop: tabs normales
          tabButtons.forEach(b => b.classList.remove('active'));
          tabContents.forEach(c => c.style.display = 'none');
          btn.classList.add('active');
          tabContents[idx].style.display = 'flex';
        }
      });
    });

    // Activar primer tab por defecto solo en desktop
    if (!isMobile() && tabButtons[0]) {
      tabButtons[0].classList.add('active');
      tabContents[0].style.display = 'flex';
    }
  });
  document.addEventListener('DOMContentLoaded', function () {
    const accordionButtons = document.querySelectorAll('.accordion-btn');
    const accordionPanels = document.querySelectorAll('.accordion-panel');

    accordionButtons.forEach((btn, idx) => {
      btn.addEventListener('click', function () {
        const isOpen = accordionPanels[idx].style.display === 'block';
        // Cerrar todos
        accordionPanels.forEach(panel => panel.style.display = 'none');
        accordionButtons.forEach(b => b.classList.remove('active'));
        if (!isOpen) {
          accordionPanels[idx].style.display = 'block';
          btn.classList.add('active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-cards-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var instances = {};

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function parseConfig(root) {
    try {
      return JSON.parse(root.getAttribute('data-mcc-config') || '{}');
    } catch (e) {
      return {};
    }
  }

  function loadLazyIframe(iframe) {
    if (!iframe || iframe.src || !iframe.dataset.src) return;
    iframe.src = iframe.dataset.src;
    iframe.removeAttribute('data-src');
    iframe.classList.remove('mcc__iframe--lazy');
  }

  function pauseVideosInSlide(slide) {
    if (!slide) return;
    slide.querySelectorAll('video').forEach(function (v) {
      try { v.pause(); } catch (_) {}
    });
  }

  function playVideosInSlide(slide, cfg) {
    if (!slide) return;
    slide.querySelectorAll('[data-mcc-video-wrap]').forEach(function (wrap) {
      var playViewport = wrap.getAttribute('data-play-viewport') === 'true';
      var autoplay = wrap.getAttribute('data-video-autoplay') === 'true';
      if (!playViewport && !autoplay) return;

      var video = wrap.querySelector('video');
      if (video) {
        if (video.muted !== true) video.muted = true;
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
      wrap.querySelectorAll('.mcc__iframe--lazy').forEach(loadLazyIframe);
      var playBtn = wrap.querySelector('[data-mcc-play-btn]');
      if (playBtn) playBtn.hidden = true;
    });
  }

  function isSlideVisibleInSwiper(slide, swEl) {
    if (!slide || !swEl) return false;
    var s = slide.getBoundingClientRect();
    var c = swEl.getBoundingClientRect();
    if (s.width <= 0) return false;
    var overlap = Math.min(s.right, c.right) - Math.max(s.left, c.left);
    return overlap > s.width * 0.35;
  }

  function syncVideos(root, swEl) {
    if (!root || !swEl) return;
    root.querySelectorAll('.swiper-slide').forEach(function (slide) {
      if (!slide.querySelector('[data-mcc-video-wrap]')) return;
      if (isSlideVisibleInSwiper(slide, swEl)) {
        playVideosInSlide(slide, null);
      } else {
        pauseVideosInSlide(slide);
      }
    });
  }

  function navigateCardLink(linkEl) {
    if (!linkEl || !linkEl.href) return;
    if (linkEl.target === '_blank') {
      window.open(linkEl.href, '_blank', 'noopener,noreferrer');
    } else {
      window.location.href = linkEl.href;
    }
  }

  function toggleVideoPlay(wrap) {
    if (!wrap) return;
    var video = wrap.querySelector('video');
    var playBtn = wrap.querySelector('[data-mcc-play-btn]');
    if (video) {
      if (video.paused) {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
        if (playBtn) playBtn.hidden = true;
      } else {
        video.pause();
        if (playBtn) playBtn.hidden = false;
      }
      return;
    }
    wrap.querySelectorAll('.mcc__iframe--lazy').forEach(loadLazyIframe);
    var poster = wrap.querySelector('.mcc__poster');
    if (poster) poster.style.display = 'none';
    if (playBtn) playBtn.hidden = true;
  }

  function bindVideoControls(root) {
    if (root.dataset.mccVideoBound === 'true') return;
    root.dataset.mccVideoBound = 'true';

    root.addEventListener('click', function (e) {
      var wrap = e.target.closest('[data-mcc-video-wrap]');
      if (!wrap || !root.contains(wrap)) return;

      var hasLink = wrap.getAttribute('data-mcc-has-link') === 'true';
      var cardLink = wrap.closest('a.mcc__card-link');
      var btn = e.target.closest('[data-mcc-play-btn]');
      var hitVideo = e.target.closest('video, .mcc__video, .mcc__iframe-wrap, .mcc__iframe, .mcc__poster');

      if (hasLink) {
        e.preventDefault();
        e.stopPropagation();
        if (cardLink) navigateCardLink(cardLink);
        return;
      }

      if (btn || hitVideo) {
        e.preventDefault();
        e.stopPropagation();
        toggleVideoPlay(wrap);
      }
    });
  }

  function markImgLoaded(img) {
    if (!img) return;
    img.classList.add('mcc__img--loaded');
    var media = img.closest('.mcc__media');
    if (media) {
      var pending = media.querySelectorAll('.mcc__img:not(.mcc__img--loaded), .mcc__poster:not(.mcc__img--loaded)');
      if (!pending.length) media.classList.remove('mcc__media--loading');
    }
  }

  function setupMediaLoading(root) {
    root.querySelectorAll('.mcc__media').forEach(function (media) {
      media.classList.add('mcc__media--loading');
      var imgs = media.querySelectorAll('.mcc__img, .mcc__poster');
      if (!imgs.length) {
        if (media.querySelector('.mcc__placeholder, .mcc__iframe-wrap, video')) {
          /* iframe/video: se limpia en listeners abajo o al quedar listo el swiper */
          if (media.querySelector('.mcc__placeholder')) {
            media.classList.remove('mcc__media--loading');
          }
        }
        return;
      }
      imgs.forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) {
          markImgLoaded(img);
        } else {
          img.addEventListener('load', function () { markImgLoaded(img); }, { once: true });
          img.addEventListener('error', function () { markImgLoaded(img); }, { once: true });
        }
      });
    });

    root.querySelectorAll('[data-mcc-video-wrap] video').forEach(function (video) {
      var media = video.closest('.mcc__media');
      if (!media) return;
      var clear = function () { media.classList.remove('mcc__media--loading'); };
      if (video.readyState >= 2) {
        clear();
      } else {
        video.addEventListener('loadeddata', clear, { once: true });
        video.addEventListener('error', clear, { once: true });
      }
    });

    /* Embeds externos: quitar skeleton cuando el swiper esté listo (poster/iframe ya reservan espacio) */
    root.querySelectorAll('[data-mcc-video-wrap] .mcc__iframe-wrap').forEach(function (el) {
      var media = el.closest('.mcc__media');
      if (media && !media.querySelector('video, .mcc__poster')) {
        media.classList.remove('mcc__media--loading');
      }
    });
  }

  function setupVideoObserver(root) {
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var wrap = entry.target;
        var slide = wrap.closest('.swiper-slide');
        if (!entry.isIntersecting) {
          pauseVideosInSlide(slide);
          return;
        }
        var playViewport = wrap.getAttribute('data-play-viewport') === 'true';
        var autoplay = wrap.getAttribute('data-video-autoplay') === 'true';
        if (!playViewport && !autoplay) return;
        playVideosInSlide(slide, null);
      });
    }, { root: null, threshold: 0.35 });

    root.querySelectorAll('[data-mcc-video-wrap]').forEach(function (el) {
      var playViewport = el.getAttribute('data-play-viewport') === 'true';
      var autoplay = el.getAttribute('data-video-autoplay') === 'true';
      if (playViewport || autoplay) observer.observe(el);
    });
    root._mccVideoObserver = observer;
  }

  function destroySection(root) {
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    var swEl = document.getElementById('mcc-swp-' + sectionId);
    if (swEl && swEl.swiper) {
      swEl.swiper.destroy(true, true);
    }
    if (root._mccVideoObserver) {
      root._mccVideoObserver.disconnect();
      delete root._mccVideoObserver;
    }
    root.classList.remove('mcc--ready');
    delete root.dataset.mccVideoBound;
    delete instances[sectionId];
  }

  function initSection(root, attempt) {
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;

    var swEl = document.getElementById('mcc-swp-' + sectionId);
    if (!swEl) return;

    if (typeof Swiper === 'undefined') {
      if ((attempt || 0) < 60) {
        setTimeout(function () { initSection(root, (attempt || 0) + 1); }, 50);
      }
      return;
    }

    destroySection(root);
    root.classList.remove('mcc--ready');
    setupMediaLoading(root);

    var cfg = parseConfig(root);
    var slideCount = cfg.slideCount || swEl.querySelectorAll('.swiper-slide').length;
    var maxSlides = Math.max(cfg.slidesDesktop, cfg.slidesTablet, cfg.slidesMobile);
    var canLoop = cfg.loop && slideCount > 1 && slideCount >= Math.ceil(maxSlides) * 2;

    var paginationEl = root.querySelector('.mcc-swp-pg-' + sectionId);
    var paginationType = cfg.paginationStyle || 'bullets';
    if (paginationType === 'progressbar') paginationType = 'progressbar';
    if (paginationType === 'fraction') paginationType = 'fraction';

    var autoplay = false;
    if (cfg.autoplay && !prefersReducedMotion()) {
      autoplay = {
        delay: cfg.autoplaySpeed || 5000,
        pauseOnMouseEnter: !!cfg.pauseOnHover,
        disableOnInteraction: !!cfg.pauseOnInteract
      };
    }

    var swiperOpts = {
      slidesPerView: cfg.slidesDesktop || 4,
      spaceBetween: cfg.gapDesktop || 0,
      loop: canLoop,
      centeredSlides: !!cfg.centered,
      freeMode: !!cfg.freeScroll,
      grabCursor: true,
      speed: cfg.transitionSpeed || 400,
      autoplay: autoplay,
      watchOverflow: true,
      resistanceRatio: 0.65,
      navigation: {
        nextEl: '.mcc-swp-next-' + sectionId,
        prevEl: '.mcc-swp-prev-' + sectionId
      },
      pagination: paginationEl ? {
        el: paginationEl,
        clickable: true,
        type: paginationType
      } : false,
      breakpoints: {
        0: {
          slidesPerView: cfg.slidesMobile || 1.2,
          spaceBetween: cfg.gapMobile || 0
        },
        767: {
          slidesPerView: cfg.slidesTablet || 3,
          spaceBetween: cfg.gapTablet || 0
        },
        1025: {
          slidesPerView: cfg.slidesDesktop || 4,
          spaceBetween: cfg.gapDesktop || 0
        }
      },
      on: {
        init: function (swiper) {
          root.classList.add('mcc--ready');
          syncVideos(root, swiper.el);
        },
        slideChange: function (swiper) {
          syncVideos(root, swiper.el);
        },
        transitionEnd: function (swiper) {
          syncVideos(root, swiper.el);
        }
      }
    };

    var swiper = new Swiper('#mcc-swp-' + sectionId, swiperOpts);
    instances[sectionId] = swiper;

    bindVideoControls(root);
    setupVideoObserver(root);
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="media-cards-carousel"]').forEach(function (root) {
      initSection(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.detail || !e.detail.sectionId) return;
    var sectionEl = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!sectionEl) return;
    var root = sectionEl.querySelector('[data-section-type="media-cards-carousel"]');
    if (root) initSection(root);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.detail || !e.detail.sectionId) return;
    var sectionEl = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!sectionEl) return;
    var root = sectionEl.querySelector('[data-section-type="media-cards-carousel"]');
    if (root) destroySection(root);
  });

  document.addEventListener('shopify:block:select', function (e) {
    if (!e.detail || !e.detail.sectionId || e.detail.blockId == null) return;
    var sectionId = e.detail.sectionId;
    var swiper = instances[sectionId];
    if (!swiper) return;
    var blockEl = document.querySelector('[data-block-id="' + e.detail.blockId + '"]');
    if (!blockEl) return;
    var slide = blockEl.closest('.swiper-slide');
    if (!slide) return;
    var index = Array.prototype.indexOf.call(swiper.slides, slide);
    if (index >= 0) swiper.slideTo(index);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__stlLookHotspotBound) return;
  window.__stlLookHotspotBound = true;

  var stlDesktopMq = window.matchMedia('(min-width: 767px)');
  var stlMobileMq = window.matchMedia('(max-width: 766px)');
  var stlLayoutSwipers = [];
  var stlOpenPopup = null;

  function getPopupSpaceBetween(popupEl) {
    var spaceBetween = parseInt(popupEl.getAttribute('data-space-between'), 10);
    return isNaN(spaceBetween) ? 12 : spaceBetween;
  }

  function initStlPopupSwiper(popupEl) {
    if (popupEl._stlPopupSwiper) return popupEl._stlPopupSwiper;
    var swEl = popupEl.querySelector('.stl-mobile-popup__swiper');
    if (!swEl || typeof Swiper === 'undefined') return null;
    popupEl._stlPopupSwiper = new Swiper(swEl, {
      slidesPerView: 1,
      centeredSlides: false,
      centerInsufficientSlides: false,
      spaceBetween: getPopupSpaceBetween(popupEl),
      loop: false,
      grabCursor: true
    });
    popupEl._stlPopupSwiper.on('slideChange', function (swiper) {
      var sectionId = popupEl.id.replace('stlPopup-', '');
      setHotspotActive(sectionId, swiper.activeIndex);
    });
    return popupEl._stlPopupSwiper;
  }

  function closeStlMobilePopup(popupEl) {
    if (!popupEl) return;
    popupEl.classList.remove('is-open', 'is-positioned');
    popupEl.setAttribute('aria-hidden', 'true');
    if (stlOpenPopup === popupEl) stlOpenPopup = null;
    if (!document.querySelector('.stl-mobile-popup.is-open')) {
      document.body.classList.remove('stl-popup-open');
    }
  }

  function closeAllStlMobilePopups() {
    document.querySelectorAll('.stl-mobile-popup.is-open').forEach(closeStlMobilePopup);
  }

  function openStlMobilePopup(sectionId, index) {
    var popupEl = document.getElementById('stlPopup-' + sectionId);
    if (!popupEl) return;
    closeAllStlMobilePopups();

    function tryOpen(attempts) {
      if (attempts > 120) return;
      var swiper = initStlPopupSwiper(popupEl);
      if (!swiper) {
        requestAnimationFrame(function () {
          tryOpen(attempts + 1);
        });
        return;
      }
      popupEl.classList.add('is-open');
      popupEl.classList.remove('is-positioned');
      popupEl.setAttribute('aria-hidden', 'false');
      document.body.classList.add('stl-popup-open');
      stlOpenPopup = popupEl;
      requestAnimationFrame(function () {
        swiper.update();
        swiper.slideTo(index, 0, false);
        popupEl.classList.add('is-positioned');
        setHotspotActive(sectionId, index);
      });
    }
    tryOpen(0);
  }

  function initAllStlPopupSwipers() {
    document.querySelectorAll('.shopLookCarousel .stl-mobile-popup').forEach(function (popupEl) {
      if (stlMobileMq.matches) initStlPopupSwiper(popupEl);
    });
  }

  function applyStlCarouselLayout(swEl) {
    var swiper = swEl.swiper;
    if (!swiper) return;
    var spaceBetween = parseInt(swEl.getAttribute('data-space-between'), 10);
    if (isNaN(spaceBetween)) spaceBetween = 12;
    var loopEnabled = swEl.getAttribute('data-loop') === 'true';
    var activeIndex = typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex;

    if (stlDesktopMq.matches) {
      var desktopIndex = typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex;
      if (swiper.params.loop && typeof swiper.loopDestroy === 'function') {
        swiper.params.loop = false;
        swiper.loopDestroy();
      }
      var slideCount = swiper.slides ? swiper.slides.length : 0;
      var perView = slideCount > 2 ? 2.35 : Math.max(slideCount, 1);
      swiper.params.centeredSlides = false;
      swiper.params.centerInsufficientSlides = false;
      swiper.params.slidesPerView = perView;
      swiper.params.spaceBetween = spaceBetween;
      swiper.el.classList.remove('swiper-centered');
      swiper.update();
      swiper.slideTo(desktopIndex, 0, false);
    } else {
      swiper.params.centeredSlides = true;
      swiper.params.centerInsufficientSlides = false;
      swiper.params.slidesPerView = 'auto';
      swiper.params.spaceBetween = spaceBetween;
      if (loopEnabled && !swiper.params.loop && typeof swiper.loopCreate === 'function') {
        swiper.params.loop = true;
        swiper.loopCreate();
      }
      swiper.update();
      if (loopEnabled && typeof swiper.slideToLoop === 'function') {
        swiper.slideToLoop(activeIndex, 0, false);
      } else {
        swiper.slideTo(activeIndex, 0, false);
      }
    }
  }

  function configureStlCarouselLayout(swEl) {
    if (!swEl || !swEl.classList.contains('stl-swiper-peek')) return;

    function tryConfigure(attempts) {
      if (attempts > 120) return;
      if (!swEl.swiper) {
        requestAnimationFrame(function () {
          tryConfigure(attempts + 1);
        });
        return;
      }
      applyStlCarouselLayout(swEl);
      if (stlLayoutSwipers.indexOf(swEl) === -1) {
        stlLayoutSwipers.push(swEl);
      }
    }
    tryConfigure(0);
  }

  function initAllStlCarouselLayouts() {
    document.querySelectorAll('.shopLookCarousel .stl-swiper-peek.swiper').forEach(function (swEl) {
      configureStlCarouselLayout(swEl);
    });
  }

  stlDesktopMq.addEventListener('change', function () {
    stlLayoutSwipers.forEach(applyStlCarouselLayout);
  });

  function setHotspotActive(sectionId, index) {
    document.querySelectorAll('.stl-hotspot[data-hotspot-section="' + sectionId + '"]').forEach(function (h) {
      var i = parseInt(h.getAttribute('data-index'), 10);
      var on = i === index;
      h.classList.toggle('stl-hotspot--active', on);
      if (on) {
        h.setAttribute('aria-current', 'true');
      } else {
        h.removeAttribute('aria-current');
      }
    });
  }

  function getSlideIndex(swiper) {
    if (swiper.params.loop && typeof swiper.realIndex === 'number') {
      return swiper.realIndex;
    }
    return swiper.activeIndex;
  }

  function bindHotspotSync(sectionId) {
    var swEl = document.getElementById('swp' + sectionId);
    if (!swEl) return;
    var state = swEl.getAttribute('data-stl-hotspot-sync');
    if (state === '1' || state === 'pending') return;
    swEl.setAttribute('data-stl-hotspot-sync', 'pending');

    function tryBind(attempts) {
      if (attempts > 120) {
        swEl.removeAttribute('data-stl-hotspot-sync');
        return;
      }
      var swiper = swEl.swiper;
      if (!swiper) {
        requestAnimationFrame(function () {
          tryBind(attempts + 1);
        });
        return;
      }
      swEl.setAttribute('data-stl-hotspot-sync', '1');
      swiper.on('slideChange', function () {
        setHotspotActive(sectionId, getSlideIndex(swiper));
      });
      setHotspotActive(sectionId, getSlideIndex(swiper));
    }
    tryBind(0);
  }

  function initAllHotspotSyncs() {
    var seen = {};
    document.querySelectorAll('.stl-hotspot[data-hotspot-section]').forEach(function (h) {
      var sid = h.getAttribute('data-hotspot-section');
      if (sid && !seen[sid]) {
        seen[sid] = true;
        bindHotspotSync(sid);
      }
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-stl-popup-close]')) {
      closeStlMobilePopup(e.target.closest('.stl-mobile-popup'));
      return;
    }
    var hotspot = e.target.closest('.stl-hotspot');
    if (!hotspot) return;
    var sid = hotspot.getAttribute('data-hotspot-section');
    if (!sid) return;
    var idx = parseInt(hotspot.getAttribute('data-index'), 10);
    if (isNaN(idx)) return;
    if (stlMobileMq.matches) {
      e.preventDefault();
      openStlMobilePopup(sid, idx);
      return;
    }
    var swEl = document.getElementById('swp' + sid);
    if (!swEl || !swEl.swiper) return;
    var swiper = swEl.swiper;
    if (swiper.params.loop && typeof swiper.slideToLoop === 'function') {
      swiper.slideToLoop(idx);
    } else {
      swiper.slideTo(idx);
    }
    setHotspotActive(sid, idx);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllStlMobilePopups();
  });

  stlMobileMq.addEventListener('change', function () {
    if (!stlMobileMq.matches) closeAllStlMobilePopups();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllHotspotSyncs();
      initAllStlCarouselLayouts();
      initAllStlPopupSwipers();
    });
  } else {
    initAllHotspotSyncs();
    initAllStlCarouselLayouts();
    initAllStlPopupSwipers();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.detail || !e.detail.sectionId) return;
    var root = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!root || !root.querySelector('.stl-hotspot')) return;
    var swp = root.querySelector('[id^="swp"]');
    if (swp) {
      swp.removeAttribute('data-stl-hotspot-sync');
      var idx = stlLayoutSwipers.indexOf(swp);
      if (idx !== -1) stlLayoutSwipers.splice(idx, 1);
    }
    var popup = root.querySelector('.stl-mobile-popup');
    if (popup && popup._stlPopupSwiper) {
      popup._stlPopupSwiper.destroy(true, true);
      popup._stlPopupSwiper = null;
    }
    var seen = {};
    root.querySelectorAll('.stl-hotspot[data-hotspot-section]').forEach(function (h) {
      var sid = h.getAttribute('data-hotspot-section');
      if (sid && !seen[sid]) {
        seen[sid] = true;
        bindHotspotSync(sid);
      }
    });
    root.querySelectorAll('.stl-swiper-peek.swiper').forEach(configureStlCarouselLayout);
    if (popup) initStlPopupSwiper(popup);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-text-feature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function startVtfVideos(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var videos = scope.querySelectorAll('.vtf__video-el');
      Array.prototype.forEach.call(videos, function (video) {
        if (!video.autoplay && !video.hasAttribute('autoplay')) return;
        if (window.theme && typeof theme.playInlineVideo === 'function') {
          theme.playInlineVideo(video, { allowSound: video.getAttribute('data-gmk-allow-sound') === 'true' });
        }
      });
    }

    function bootVtfVideos() {
      startVtfVideos(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootVtfVideos);
    } else {
      bootVtfVideos();
    }

    document.addEventListener('shopify:section:load', function (event) {
      startVtfVideos(event.target);
    });

    if (window.__vtfSoundBound) return;
    window.__vtfSoundBound = true;

    function isIframeLoaded(iframe) {
      return !!iframe.getAttribute('src') || iframe.classList.contains('lazyloaded');
    }

    function sendWhenReady(iframe, payloads) {
      var send = function () {
        if (!iframe.contentWindow) return;
        payloads.forEach(function (p) {
          iframe.contentWindow.postMessage(typeof p === 'string' ? p : JSON.stringify(p), '*');
        });
      };
      if (isIframeLoaded(iframe)) {
        send();
      } else {
        iframe.addEventListener('load', send, { once: true });
      }
    }

    function syncButton(btn, muted) {
      btn.dataset.vtfMuted = muted ? 'true' : 'false';
      btn.setAttribute('aria-pressed', muted ? 'false' : 'true');
      btn.setAttribute('aria-label', muted ? 'Activar audio del video' : 'Silenciar video');
      var icM = btn.querySelector('.vtf__sound__icon--muted');
      var icU = btn.querySelector('.vtf__sound__icon--unmuted');
      if (icM) icM.hidden = !muted;
      if (icU) icU.hidden = muted;
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vtf-sound]');
      if (!btn) return;
      var wrap = btn.closest('.vtf__video');
      if (!wrap) return;

      var nextMuted = btn.dataset.vtfMuted !== 'true';
      var video = wrap.querySelector('video');
      var iframe = wrap.querySelector('iframe');

      if (video) {
        video.muted = nextMuted;
        if (!nextMuted) {
          video.volume = 1;
          var playPromise = video.play();
          if (playPromise && playPromise.catch) playPromise.catch(function () {});
        }
      } else if (iframe) {
        var src = iframe.getAttribute('src') || iframe.getAttribute('data-src') || '';
        if (src.indexOf('youtube') !== -1) {
          var ytPayloads = [
            { event: 'listening', id: 1, channel: 'widget' },
            { event: 'command', func: nextMuted ? 'mute' : 'unMute', args: [] }
          ];
          if (!nextMuted) {
            ytPayloads.push({ event: 'command', func: 'setVolume', args: [100] });
            ytPayloads.push({ event: 'command', func: 'playVideo', args: [] });
          }
          sendWhenReady(iframe, ytPayloads);
        } else if (src.indexOf('vimeo') !== -1) {
          var vmPayloads = [
            { method: 'setMuted', value: nextMuted },
            { method: 'setVolume', value: nextMuted ? 0 : 1 }
          ];
          if (!nextMuted) vmPayloads.push({ method: 'play' });
          sendWhenReady(iframe, vmPayloads);
        }
      }

      syncButton(btn, nextMuted);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-info"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initWholesaleInfo(root) {
      if (!root || !root.hasAttribute('data-wi-animate')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        root.classList.add('wi-sec--in-view');
        return;
      }
      if (!('IntersectionObserver' in window)) {
        root.classList.add('wi-sec--in-view');
        return;
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('wi-sec--in-view');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
      );
      observer.observe(root);
    }

    function boot() {
      document.querySelectorAll('[data-wi-animate]').forEach(initWholesaleInfo);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var el =
        event.target && event.target.querySelector
          ? event.target.querySelector('[data-wi-animate]')
          : null;
      if (el) initWholesaleInfo(el);
      if (event.target && event.target.hasAttribute && event.target.hasAttribute('data-wi-animate')) {
        initWholesaleInfo(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
